export const CREATURE_IDENTIFICATION_TRAITS: string[] = [
    "aberration",
    "animal",
    "astral",
    "beast",
    "celestial",
    "construct",
    "dragon",
    "dream",
    "elemental",
    "ethereal",
    "fey",
    "fiend",
    "fungus",
    "humanoid",
    "monitor",
    "ooze",
    "plant",
    "shade",
    "spirit",
    "time",
    "undead",
];

export const ELITE_WEAK: string[] = ["elite", "weak"];
